// extracted by mini-css-extract-plugin
export default {"table":"AcademicVacationList_table__SLQmL"};